<template>
  <div class="container">
    <div class="corpo-pagina">
      <div class="row row-text">
        <div class="col s1"></div>
        <div class="col s10 content-container">

          <h4>Crea Nuova Stanza</h4>

          <form @submit.prevent="createRoom">

            <div class="input-field">
              <input id="name" type="text" v-model.trim="formData.name" required>
              <label for="name">Nome Stanza</label>
            </div>

            <div class="input-field">
              <textarea id="description" class="materialize-textarea" v-model="formData.description"></textarea>
              <label for="description">Descrizione</label>
            </div>

            <div class="row">
              <div class="col s12">
                <p>
                  <label>
                    <input type="checkbox" v-model="useColor" />
                    <span>Usa Colore (spunta per il colore, altrimenti usa Immagine)</span>
                  </label>
                </p>
              </div>
            </div>

            <div class="input-field" v-if="useColor">
              <label for="color" class="active">Colore (HEX)</label>
              <input id="color" type="color" v-model="formData.color">
            </div>

            <div :key="useColor ? 'color-active' : 'image-active'" v-else class="row">

              <div class="col s12 m6 l6">
                <div class="input-field">
                  <select v-model="formData.img" id="img_select_reactive">
                    <option value="" disabled selected>Scegli un'immagine</option>
                    <option v-for="imgOption in imageOptions" :key="imgOption.value" :value="imgOption.value"
                      :data-icon="imgOption.path" class="room-image-option circle">
                      {{ imgOption.text }}
                    </option>
                  </select>
                  <label>Immagine Stanza</label>
                </div>
              </div>

              <div class="col s12 m6 l6 center-align">
                <div v-if="formData.img && selectedImagePath" class="image-preview-container">
                  <img :src="selectedImagePath" alt="Anteprima Stanza" class="responsive-img z-depth-1 room-preview-img" />
                </div>
                <div v-else class="image-preview-container no-image">
                    <i class="material-icons large grey-text text-lighten-2">image</i>
                    <p class="grey-text">Anteprima Immagine</p>
                </div>
              </div>

            </div>

            <button class="btn waves-effect waves-light" type="submit" :disabled="loadingStore.getters.isLoading">
              Crea Stanza
              <i class="material-icons right">send</i>
            </button>

            <p v-if="loadingStore.getters.isLoading" class="blue-text">Invio in corso...</p>
            <p v-if="successMessage" class="green-text">{{ successMessage }}</p>
            <p v-if="errorMessage" class="red-text">{{ errorMessage }}</p>

          </form>

        </div>
        <div class="col s1"></div>
      </div>
    </div>
  </div>
</template>

<script>
import loadingStore from '@/store/loading'
import konovaschema from '@/store/konovaschema.js'
import useAuthStore from '@/store/authStore.js'
import apiService from '@/services/apiService.js'
import eventSetting from '@/store/eventSettings.js'
import M from 'materialize-css'

// Schema Konva richiesto dal backend
const KONVA_SCHEMA_BASE = {
  attrs: { width: 800, height: 600 },
  className: 'Stage',
  children: [
    {
      attrs: {},
      className: 'Layer',
      children: [
        { attrs: { width: 800, height: 600, stroke: 'black', id: 'stage-border' }, className: 'Rect' }
      ]
    },
    {
      attrs: { name: 'TableLayer' },
      className: 'Layer',
      children: [
        { attrs: { borderStroke: 'blue', anchorFill: 'blue', anchorStroke: 'blue', enabledAnchors: [] }, className: 'Transformer' }
      ]
    },
    { attrs: { name: 'FigureLayer' }, className: 'Layer', children: [] }
  ]
}

export default {
  name: 'RoomCreateView',
  data () {
    return {
      loadingStore: loadingStore,

      useColor: false,
      formData: {
        name: '',
        description: '',
        color: '#ffffff',
        img: '',
        jsonable: {}
      },

      // *** SOLO OPZIONI PREFISSATE ***
      imageOptions: [
        { value: 'modern', path: require('@/assets/img/table/modern.png'), text: 'Sala Modern' },
        { value: 'liberty', path: require('@/assets/img/table/liberty.png'), text: 'Sala Liberty' },
        { value: 'principesco', path: require('@/assets/img/table/principesco.png'), text: 'Sala Principesca' },
        { value: 'elegante', path: require('@/assets/img/table/rosomi.png'), text: 'Sala Elegante' },
        { value: 'natale', path: require('@/assets/img/table/natale.png'), text: 'Sala Natalizia' }
      ],

      successMessage: null,
      errorMessage: null
    }
  },
  computed: {
    isAuth () {
      return useAuthStore.getters.isAuthenticated
    },
    fullEventData () {
      return eventSetting.getters.eventModel || {}
    },
    uidEvent () {
      return this.fullEventData.uid || null
    },
    /**
     * Calcola il percorso completo dell'immagine selezionata per l'anteprima.
     */
    selectedImagePath () {
      const selectedOption = this.imageOptions.find(opt => opt.value === this.formData.img)
      // Restituisce il percorso risolto da require() per l'anteprima
      return selectedOption ? selectedOption.path : ''
    }
  },
  methods: {
    /**
     * Inizializza o aggiorna il componente select di Materialize.
     */
    initializeMaterializeSelect () {
      this.$nextTick(() => {
        const selectElem = document.getElementById('img_select_reactive')
        if (selectElem && M) {
          // Inizializza o de-inizializza/ri-inizializza se necessario
          M.FormSelect.init(selectElem)
        }
      })
    },

    async createRoom () {
      this.successMessage = null
      this.errorMessage = null

      const uid = this.uidEvent
      if (!uid) {
        this.errorMessage = 'Errore: UID Evento non disponibile. Impossibile creare la stanza.'
        return
      }

      this.loadingStore.commit('setLoading', true)

      const tableIdentifier = `table-${this.formData.name.toLowerCase().replace(/\s/g, '-')}`

      const jsonablePayload = {
        table: tableIdentifier,
        konva_schema: KONVA_SCHEMA_BASE
      }

      const payload = {
        name: this.formData.name,
        description: this.formData.description,
        event_uid: uid,
        jsonable: jsonablePayload
      }

      // 4. Inserimento di colore o immagine nel payload
      if (this.useColor) {
        if (this.formData.color && this.formData.color !== '#ffffff') {
          payload.color = this.formData.color
          payload.img = null
        }
      } else {
        const selectedImgOption = this.imageOptions.find(opt => opt.value === this.formData.img)

        if (selectedImgOption) {
          // Manda al backend solo il VALUE (es. 'modern'), non il percorso completo
          payload.img = selectedImgOption.value
          payload.color = null
        } else {
          this.errorMessage = 'Errore: Devi selezionare un\'immagine se non usi il colore.'
          this.loadingStore.commit('setLoading', false)
          return
        }
      }

      const token = await apiService.getClientCredentialsToken()
      if (!token) {
        this.$router.push('/error')
        this.loadingStore.commit('setLoading', false)
        return
      }

      const url = process.env.VUE_APP_URL_EVENTS + '/table/create-room'

      try {
        const json = await apiService.sendRequestWithBearer('POST', url, token, payload)
        this.successMessage = `Stanza "${json.name || payload.name}" creata con successo!`

        // Salvataggio dei dati completi della stanza appena creata in Vuex
        await this.setDataRoom(json)

        this.$router.push('/table-manager')
      } catch (error) {
        console.error('Errore durante la creazione della stanza:', error)
        this.errorMessage = `Errore di creazione: ${error.message || 'Verifica i dati inseriti.'}`
      } finally {
        this.loadingStore.commit('setLoading', false)
      }
    },

    async setDataRoom (json) {
      konovaschema.commit('setRoomData', json)
    },

    resetForm () {
      this.formData.name = ''
      this.formData.description = ''
      this.formData.color = '#ffffff'
      this.formData.img = ''
      this.useColor = false

      this.$nextTick(() => {
        if (typeof M !== 'undefined') {
          M.updateTextFields()
          this.initializeMaterializeSelect()
        }
      })
    }
  },
  mounted () {
    if (typeof M !== 'undefined') {
      M.updateTextFields()
    }
    // Inizializza la select al mount
    this.initializeMaterializeSelect()
  },
  watch: {
    useColor (newVal) {
      if (newVal) {
        this.formData.img = ''
      } else {
        this.formData.color = '#ffffff'
        // Forza la ri-inizializzazione della select quando si passa a Immagine
        this.initializeMaterializeSelect()
      }
    },
    'formData.img' () {
      // Forza la ri-inizializzazione della select quando il modello cambia
      if (!this.useColor) {
        this.initializeMaterializeSelect()
      }
    }
  }
}
</script>

<style>
/* !!! IMPORTANTE !!!
Rimosso 'scoped' per permettere a questi stili di raggiungere il dropdown
che Materialize crea fuori dal componente.
*/

.content-container {
  padding: 20px;
  line-height: 1.6;
  color: #333;
}
.input-field input[type=color] {
  height: 40px;
  width: 100%;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.row p {
  margin-top: 20px;
  margin-bottom: 20px;
}

/* --- STILI ANTEPRIMA IMMAGINE --- */
.image-preview-container {
    height: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px dashed #ccc;
    border-radius: 5px;
    margin-top: 20px;
    overflow: hidden;
}
.image-preview-container.no-image {
    flex-direction: column;
}
.room-preview-img {
    max-height: 100%;
    width: auto;
    object-fit: contain;
}

/* ------------------------------------------- */
/* STILI PER SOVRASCRIVERE MATERIALIZE (Dropdown: Immagine a Sinistra e Più Grande) */
/* ------------------------------------------- */

/* 1. Stile del Contenitore (<li>) - Applica Flexbox */
.dropdown-content li.room-image-option {
    display: flex !important;
    align-items: center !important;
    min-height: 58px !important;
    padding-left: 10px !important;
}

/* 2. Stile dell'Immagine (<img>) - Rimuove float e posiziona a sinistra */
.dropdown-content li.room-image-option img {
    float: none !important;
    order: 1 !important;
    width: 48px !important;
    height: 48px !important;
    margin-right: 12px !important;
    margin-left: 0 !important;
}

/* 3. Stile del Testo */
.dropdown-content li.room-image-option {
    line-height: normal !important;
}

/* 4. Regola l'altezza del campo di input della select */
.select-wrapper input.select-dropdown {
    height: 58px !important;
    line-height: 58px !important;
}

/* 5. FIX per la label mobile */
.select-wrapper input.select-dropdown.active + label,
.select-wrapper input.select-dropdown:focus + label {
    top: -14px !important;
}
</style>
